import {useEffect, useState} from "preact/hooks";
import {useValidatePath} from "../hooks";

export const useApp = () => {
    const {
        setPathLocation,
        isSpecialPath,
        pathLocation,
        rawPathName,
        isCheckout,
        isNad,
        shouldRenderHeader,
        shouldRenderPromoBanner
    } = useValidatePath();

    const [hasPromoBanner, setHasPromoBanner] = useState(false);

    const canRenderPromoBanner = shouldRenderPromoBanner;

    // Reset header offset as soon as the banner leaves the DOM.
    // Without this, hasPromoBanner stays true after unmount and the header
    // keeps top:5rem with nothing above it.
    useEffect(() => {
        if (!canRenderPromoBanner) {
            setHasPromoBanner(false);
        }
    }, [canRenderPromoBanner]);

    const handleRouteChange = url => {
        setPathLocation(url);
    }

    return {
        isSpecialPath,
        pathLocation,
        rawPathName,
        isCheckout,
        isNad,
        shouldRenderHeader,
        shouldRenderPromoBanner,
        canRenderPromoBanner,
        handleRouteChange,
        hasPromoBanner,
        setHasPromoBanner
    }
}
